import React from "react";
import { chakraComponents } from "chakra-react-select";
import { Flex, Text } from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";

const CustomControl = (props) => {
  return (
    <chakraComponents.Control {...props}>
      <Flex alignItems="center" w="full">
        <Text ml="2">
          <FaSearch />
        </Text>
        {props.children}
      </Flex>
    </chakraComponents.Control>
  );
};

export default CustomControl;
